import { render, staticRenderFns } from "./Medications.vue?vue&type=template&id=ae7aaf80&scoped=true"
import script from "./Medications.vue?vue&type=script&lang=js"
export * from "./Medications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae7aaf80",
  null
  
)

export default component.exports